export default __webpack_public_path__ + "static/media/menu--profile.8e98f22a.jpg";